import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import {
  Box,
  Field,
  IconButton,
  Input,
  InputGroup,
  useDisclosure,
} from "@chakra-ui/react";
import { t } from "i18next";
import { isValidEmail } from "../../../shared/utils/validation-utils";
import { UserNotFoundPrompt } from "../../../shared/views/UserNotFoundPrompt/UserNotFoundPrompt";
import { useStores } from "../../../shared/stores/RootStore";
import { AddIcon } from "../../../shared/views/icons";
import { toast } from "../../../shared/views/CustomToaster";
import { UserApi } from "../../services/UserApi";

const AddUserInputBase: React.FC = () => {
  const { accountStore } = useStores();
  const [email, setEmail] = useState("");
  const createUserModal = useDisclosure();
  const userAccount = accountStore.selectedUserAccount;

  const addAccountUser = async () => {
    const userExists = await UserApi.exists(email).then((r) => r.data);

    if (userExists) {
      await accountStore
        .createAccountUser({
          email: email,
          accountId: userAccount!.accountId,
          roles: [],
        })
        .then(() => {
          toast("success", t("account:Users.userAdded", { email }));
          setEmail("");
        })
        .catch((error) => {
          toast("error", "Request failed");
          console.error(error);
        });
    } else {
      createUserModal.onOpen();
    }
  };

  const emailIsValid = isValidEmail(email);

  return (
    <>
      <Box px={6} py={4} maxW="360px">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (emailIsValid) addAccountUser();
          }}
        >
          <Field.Root invalid={!!email && !emailIsValid}>
            <InputGroup
              endElement={
                <IconButton
                  onClick={addAccountUser}
                  variant="ghost"
                  colorPalette="primary"
                  disabled={!emailIsValid}
                >
                  <AddIcon color="primary.500" />
                </IconButton>
              }
            >
              <Input
                required
                placeholder={t("account:Users.addPlaceholder")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputGroup>
            <Field.ErrorText>{t("account:Users.invalidEmail")}</Field.ErrorText>
          </Field.Root>
        </form>
      </Box>

      {createUserModal.open && (
        <UserNotFoundPrompt
          onClose={createUserModal.onClose}
          email={email}
          onConfirm={addAccountUser}
        />
      )}
    </>
  );
};

export const AddUserInput = observer(AddUserInputBase);
